import picker from "./picker";
import resultsList from "./resultsList";

export default `
  ${picker}
  ${resultsList}
`;
